export default {
      id: "lightningStrikeCount-usage",
      viewBox: "0 0 13.963 22.39",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#lightningStrikeCount",
      toString: function () {
        return this.url;
      }
    }